import * as React from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import {LOGIN_ROUTE, REPORTS_ROUTE} from "../utils/constants";
import { observer } from "mobx-react-lite";
import { Context } from "../index";
import {getContracts, createContract, updateContract, deleteContract} from "../http/contractApi";
import {deleteUser, getAll} from "../http/userApi";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {Grid, SvgIcon} from "@mui/material";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import {useEffect} from "react";
import Divider from '@mui/material/Divider';
import SingerFields from "../components/contract/SingerFields";
import TrackFields from "../components/contract/TrackFields";
import {jwtDecode} from "jwt-decode";


const getTrackInfo = (params)=>{
  // console.log(params);
  // list, type='artist'
  let result = [];

  let list = params.row.track;
  for (const listKey in list) {
    const {artist, title} = list[listKey];
    result.push(<div style={{whiteSpace: "nowrap"}}>
      <>{result.length ? <><br /></> : null}</>
      <>{params.field === 'artist' ? artist : title}</>
    </div>);
  }

  return result;
}

const getLicensiar = (params)=>{
  // console.log(params);
  // list, type='artist'
  let result = [];

  let list = params.row.licensiar;

  for (const listKey in list) {
    // console.log(list[listKey]);
    let user = params.row.users.find(item=>item.id === list[listKey].singersId);
    if(user){
      result.push(<div style={{whiteSpace: "nowrap"}}>
        <>{result.length ? <><br/></> : null}</>
        <>{user.name}</>
      </div>);
    }
  }

  return result;
}

const renderDate = (val)=>{
  let result = val;
  let date = new Date(val);

  result = `${date.getFullYear()}-${date.getMonth() > 8 ? date.getMonth() + 1 : "0" + parseInt(date.getMonth() + 1)}-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`

  // console.log(result);

  return result;
}

const columns = [
  // {
  //   field: "id",
  //   headerName: "ID",
  //   width: 90,
  //   editable: false,
  //   sortable: true,
  // },
  {
    field: "name",
    headerName: "Номер договора",
    width: 150,
    editable: false,
    sortable: true,
    flex: 1,
    minWidth: 150,
  },
  {
    field: "artist",
    headerName: "Исполнитель",
    width: 150,
    flex: 1,
    minWidth: 150,
    editable: false,
    sortable: true,
    renderCell: getTrackInfo
  },
  {
    field: "title",
    headerName: "Трек",
    width: 150,
    flex: 1,
    minWidth: 150,
    editable: false,
    sortable: true,
    renderCell: getTrackInfo
  },
  {
    field: "licensiar",
    headerName: "Лицензиар",
    width: 150,
    flex: 1,
    minWidth: 150,
    editable: false,
    sortable: true,
    renderCell: getLicensiar
  },
  {
    field: "dateExpire",
    headerName: "Дата Окончания",
    width: 150,
    editable: false,
    sortable: true,
    valueGetter: renderDate
  },
  {
    field: "createdAt",
    headerName: "Дата Добавления",
    width: 150,
    editable: false,
    sortable: true,
    valueGetter: renderDate
  },
];


const Singers = observer(({singersList, userList, singerChange, deleteSinger})=>{
  let result = [];

  const renderItem = (singer, index)=>{
    for (const userListKey in userList) {
      if(userList[userListKey].id === singer.singersId){
        singer['singersId'] = parseInt(userListKey);
      }
    }
    return <SingerFields
      // key={"singer" + index}
      {...singer}
      userList={userList}
      onChange={(e, id)=>{singerChange(e,index)}}
      onDelete={()=>{deleteSinger(index)}}
  />}

  for (const singersListKey in singersList) {
    result.push(renderItem({
      ...singersList[singersListKey],
    }, singersListKey));
  }

  return <>{result}</>;
});

const Contracts = observer(() => {
  const [parse, setParse] = React.useState([]);
  const [dataToRender, setDataToRender] = React.useState([]);
  const [users, setUsers] = React.useState([]);
  const navigate = useNavigate();
  // const [columns, setColumns] = React.useState(null);
  const [editId, setEditId] = React.useState(0);
  const { user } = React.useContext(Context);
  const [token, setToken] = React.useState(localStorage.getItem("token") || "");
  const tkn = jwtDecode(token);
  const [form, setForm] = React.useState({
    name: '',
    vatType: "ndfl",
    profitPercent: 0,
    dateExpire: new Date(),
    tracks: [],
    singers: [],
    description: "",
    userId: tkn.id
  });
  const [showForm, setShowForm] = React.useState(false);

  const stringifyData = async (data, fields, cb, optionInfo)=>{
    let result = "";
    let count = 0;

    for (const dataKey in data) {
      const item = data[dataKey];
      // console.log(item);
      // result += item[]
      if(count){
        result += "<br />";
      }
      for (const fieldsKey in fields) {
        result += ` ${cb ? await cb(fields[fieldsKey], item[fields[fieldsKey]], optionInfo) : item[fields[fieldsKey]]}`;
      }
      count++;
    }

    return result;
  }

  const singersColRender = async (field, val, users)=>{
    let result = val;

    if(field === "singersId"){
      let user = users.filter(user => user.id === val);
      console.log(user);
      user = user.length ? user[0] : 0;
      if(user){
        result = user.name;
      }
    }

    return result;
  }

  const trackColRender = async (field, val)=>{
    let result = val;

    if(field === 'title'){
      result = " - " + val;
    }

    return result;
  }

  const getData = async () => {
    try {
      const parsed = await getContracts();
      const users = await getUsers();

      let info = [];
      let infoSaved = [];
      for (const parsedKey in parsed) {
        let row = parsed[parsedKey];
        let date = new Date(row.dateExpire);
        // console.log(date.toLocaleDateString("en-US"));
        // console.log(row);

        info.push({
          id: row['id'],
          name: row['name'],
          singer: row['tracks'],
          track: row['tracks'],
          licensiar: row['singers'],
          dateExpire: row['dateExpire'],
          createdAt: row['createdAt'],
          users
          // ...parsed[parsedKey],
          // dateExpire: `${date.getFullYear()}-${date.getMonth() > 8 ? date.getMonth() + 1 : "0" + parseInt(date.getMonth() + 1)}-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}`,
          // singers: await stringifyData(parsed[parsedKey].singers, ['singersId'], singersColRender, users),
          // tracks: await stringifyData(parsed[parsedKey].tracks, ['artist', 'title'], trackColRender),
        });
        infoSaved.push({
          ...parsed[parsedKey],
          dateExpire: `${date.getFullYear()}-${date.getMonth() > 8 ? date.getMonth() + 1 : "0" + parseInt(date.getMonth() + 1)}-${date.getDate()}`,
          singers: parsed[parsedKey].singers,
          tracks: parsed[parsedKey].tracks,
        });
      }
      setDataToRender([...info]);
      setParse([...infoSaved]);

      if(parsed.length){

        // const keys = Object.keys(parsed[0]);
        // let cols = [];
        // for (const name in keys) {
        //   // console.log(keys[name], name);
        //   let width = 200;
        //   if(keys[name] === 'id'){
        //     width = 30;
        //   }
        //   if(['userId', "vatType", "id"].includes(keys[name])){
        //     continue;
        //   }
        //   cols.push({
        //     field: keys[name],
        //     headerName: keys[name],
        //     width: width,
        //     editable: false,
        //     description: keys[name],
        //     sortable: true,
        //   });
        // }

        // setColumns(cols);

      }

    } catch (error) {
      console.log(error);
      if (error?.response?.status === 401) {
        localStorage.clear();
        user.setIsAuth(false);
        return navigate(LOGIN_ROUTE);
      }
    }
  };

  const getUsers = async () => {
    try {
      const parsed = await getAll();
      setUsers([...parsed.filter(item => (item.role === "ARTIST"))]);
      return [...parsed.filter(item => (item.role === "ARTIST"))];
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        user.setIsAuth(false);
        return navigate(LOGIN_ROUTE);
      }
    }
  };

  useEffect(() => {
    (async ()=>{
      await getUsers();
    })();
  }, []);

  useEffect(() => {
    (async ()=>{
      await getData();
    })();
  }, []);


  const onAddContract = async ()=>{
    try {
      console.log(user.getId());
      const response = await createContract({...form, userId: user.getId()});
      await getData();
      setForm({
        name: '',
        vatType: "ndfl",
        profitPercent: 0,
        userId: user.getId()
      })
      setEditId(0);
    } catch (error) {
      console.log(error);
    }
  }
  const onEditContract = async ()=>{
    try {
      const response = await updateContract(editId, {...form, userId: user.getId()});
      console.log(form);
      await getData();
      setForm({
        name: '',
        vatType: "ndfl",
        profitPercent: 0,
        dateExpire: new Date(),
        userId: user.getId()
      })
      setEditId(0);
    } catch (error) {
      console.log(error);
    }
  }

  const onDelete = async ()=>{
    console.log(editId);
    if(window.confirm("Точно удалить договор?")) {
      await deleteContract(editId);
      await getData();
      setForm({
        name: '',
        vatType: "ndfl",
        profitPercent: 0,
        dateExpire: new Date(),
        userId: user.getId()
      })
      setShowForm(false);
      setEditId(0);
    }
  }

  const onSubmit = async ()=>{
    console.log(form);
    if(editId){
      await onEditContract();
      setShowForm(false);
    } else {
      await onAddContract();
      setShowForm(false);
    }
  }

  const formChange = (e, newVal) => {
    console.log(e.target.type, e.target.value, e.target.name, newVal);
    if(e.target.type === "checkbox") {
      setForm(prevState => ({ ...prevState, [e.target.name]: e.target.checked }));
    } else if(newVal){
      setForm(prevState => ({...prevState, ["vatType"]: newVal + ""}));
    } else {
      setForm(prevState => ({...prevState, [e.target.name]: e.target.value}));
    }
  }

  const trackChange = (e, id)=>{
    setForm(prevState => {
      let result = {...prevState};
      result["tracks"][id] = {...result["tracks"][id], [e.target.name]: e.target.value}
      return result
    });
    // ({ ..., ["track"]: e.target.value }));
  }
  const singerChange = (e, id)=>{
    setForm(prevState => {
      let result = {...prevState};

      console.log(result["singers"]);
      result["singers"][id] = {...result["singers"][id], [e.target.name]: e.target.value}
      console.log(id, e.target.name, e.target.value);
      return result
    });
    // ({ ..., ["track"]: e.target.value }));
  }

  const addTrack = (e) => {
    e.preventDefault();

    setForm(prevState => ({
      ...prevState,
      ['tracks']: prevState.tracks ? [...prevState.tracks, {artist: '', title: ''}] : [{artist: '', title: ''}]
    }));
  }

  const addBeneficiary = (e) => {
    e.preventDefault();

    setForm(prevState => ({
      ...prevState,
      ['singers']: prevState.singers ? [...prevState.singers, {singersId: users[0].id, percent: 0, vat: 0, type: 0}] : [{singersId: users[0].id, percent: 0, vat: 0, type: 0}]
    }));
  }

  const deleteTrack = (id) => {
    console.log(id);
    let result = [];
    for (const tracksKey in form.tracks) {
      let item = form.tracks[tracksKey];
      console.log(tracksKey, id);
      if(parseInt(tracksKey) !== parseInt(id)){
        result.push(item);
      }
    }
    setForm({
      ...form,
      tracks: result,
    });
  }

  const deleteSinger = (id) => {
    console.log(id);
    let result = [];
    for (const singersKey in form.singers) {
      let item = form.singers[singersKey];
      if(parseInt(singersKey) !== parseInt(id)){
        result.push(item);
      }
    }
    setForm({
      ...form,
      singers: result,
    });
  }

  const rowClick = ({row})=>{
    if(row?.id){
      let {userId, createdAt, updatedAt, ...info} = row;
      setEditId(info.id);
      console.log(info);
      console.log(parse);
      let contract = parse.find(item => item.id === info.id);
      if(contract){
        setForm({
          ...info,
          dateExpire: info.dateExpire.toString().split('T')[0],
          tracks: contract.tracks,
          singers: contract.singers,
          profitPercent: contract.profitPercent,
          vatType: contract.vatType,
          description: contract.description,
          userId
        });
        setShowForm(true);
      }
    }
  };

  // console.log(form['dateExpire']);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Box
          display="flex"
          alignItems="center"
          flexDirection="row"
          justifyContent="flex-end"
          width={'100%'}
          p={2}
      >
        <Button
            color="secondary"
            variant="outlined"
            onClick={()=>{
              setEditId(0);
              setShowForm(true);
            }}
        >Создать договор</Button>
      </Box>
      <Dialog
          open={showForm}
          onClose={()=>{setShowForm(false); setEditId(0);}}
          width={800}
          my={4}
          gap={4}
          p={2}
          sx={{ border: "2px solid grey" }}
      >
        <Box
            p={2}
        >
          <Typography variant="h4" gutterBottom>
            {editId ? "Редактирование договора" : "Создание договора"}
          </Typography>
        </Box>
        <Box
            width={"100%"}
            p={2}
            rowGap={2}
            display="flex"
            flexDirection="column"
        >
          <TextField
              className="login__page__item"
              label="Номер договора"
              variant="outlined"
              color="secondary"
              name={'name'}
              value={form['name']}
              onChange={formChange}
          />
          <TextField
              className="login__page__item"
              label="Срок договора"
              variant="outlined"
              color="secondary"
              name={'dateExpire'}
              type={'date'}
              value={form['dateExpire']}
              onChange={formChange}
          />
          <TextField
              className="login__page__item"
              label="Процент вознаграждения"
              variant="outlined"
              type='number'
              color="secondary"
              name={'profitPercent'}
              value={form['profitPercent']}
              onChange={formChange}
          />
          <ToggleButtonGroup
              value={form['vatType']}
              name={'vatType'}
              exclusive
              onChange={formChange}
          >
            <ToggleButton value="nds">НДС</ToggleButton>
            <ToggleButton value="ndfl">НДФЛ</ToggleButton>
          </ToggleButtonGroup>
          <Box
              sx={{
                marginTop: 1,
                marginBottom: 1
              }}
          >
            <Box
                display={'flex'}
                flexDirection={'column'}
            >
              <Divider
              />
              <Grid
                  container
                  // display={'flex'}
                  justifyContent={'space-between'}
                  sx={{
                    marginTop: 1,
                    marginBottom: 1
                  }}
                  spacing={2}
              >
                <Grid item>
                  <Typography variant="h5" gutterBottom>Треки</Typography>
                </Grid>
                <Grid item>
                  <SvgIcon
                      color="secondary"
                      onClick={addTrack}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#ff6000">
                      <path d="M0 0h24v24H0V0z" fill="none"/>
                      <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
                    </svg>
                  </SvgIcon>
                </Grid>
              </Grid>
              <Box>
                {form.tracks && form.tracks.length > 0 ? form.tracks.map((track, index) => <TrackFields key={"track" + index} {...track} onChange={(e)=>{trackChange(e,index)}} onDelete={()=>{deleteTrack(index)}}/>) : ''}
              </Box>

            </Box>
          </Box>
          <Box
          >
            <Divider
            />
            <Box
                display={'flex'}
                justifyContent={'space-between'}
                sx={{
                  marginTop: 1,
                  marginBottom: 1
                }}
            >
              <Typography variant="h5" gutterBottom>Лицензиары</Typography>
              <SvgIcon
                  color="secondary"
                  onClick={addBeneficiary}
              >
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#ff6000">
                  <path d="M0 0h24v24H0V0z" fill="none"/>
                  <path
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
                </svg>
              </SvgIcon>
            </Box>
            <Box>
              <Singers
                  singerChange={singerChange}
                  deleteSinger={deleteSinger}
                  userList={users}
                  singersList={form.singers}
              />
            {/*{form.singers && form.singers.length > 0 ? form.singers.map((singer, index) => <SingerFields key={"singer" + index} {...userList.filter(user => user.id === )} userList={users} onChange={(e)=>{singerChange(e,index)}} onDelete={()=>{deleteSinger(index)}}/>) : ''}*/}
            </Box>
          </Box>
          <TextField
              className="login__page__item"
              label="Примечание"
              variant="outlined"
              color="secondary"
              name={'description'}
              value={form['description'] || ""}
              onChange={formChange}
              multiline
              rows={4}
          />
        </Box>
        <Box
            p={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={4}
        >
          <Button
              variant="outlined"
              color="secondary"
              onClick={()=>{
                setForm({
                  name: '',
                  vatType: "ndfl",
                  profitPercent: 0,
                  dateExpire: new Date(),
                  tracks: [],
                  singers: [],
                  description: "",
                  userId: user.getId()
                });
                setEditId(0);
                setShowForm(false);
              }}
          >
            Отмена
          </Button>
          {editId ? <Button
              variant="contained"
              color="info"
              onClick={()=>{
                navigate(REPORTS_ROUTE + '/' + editId,)
              }}
          >
            Отчеты
          </Button> : ""}
          {editId ?
              <Button
                  variant="contained"
                  color="error"
                  onClick={onDelete}
              >
                Удалить
              </Button>: null
          }
          <Button
              variant="contained"
              color="secondary"
              onClick={onSubmit}
          >
            {editId ? "Обновить договор" : "Добавить договор"}

          </Button>
        </Box>
      </Dialog>

      {parse && columns && (
        <Box sx={{ height: "100%", width: "100%" }}>
          <DataGrid
            rows={dataToRender}
            columns={columns}
            sx={{
              [`& .${gridClasses.cell}`]: {
                py: 1,
              },
            }}
            getRowHeight={() => 'auto'}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 100,
                },
              },
            }}
            pageSizeOptions={[10, 20, 50, 100]}
            disableRowSelectionOnClick
            onRowClick={rowClick}
          />
        </Box>
      )}
    </div>
  );
});

export default Contracts;
